export const MEMBERSHIP_POLICY_DUO_ROUTE = {
  key: 'MEMBERSHIP_POLICY_DUO',
  path: 'duo/',
};
export const MEMBERSHIP_POLICY_FAMILY_ROUTE = {
  key: 'MEMBERSHIP_POLICY_FAMILY',
  path: 'familiar/',
};
export const MEMBERSHIP_POLICY_PREMIUM_ROUTE = {
  key: 'MEMBERSHIP_POLICY_PREMIUM',
  path: '',
};
export const MEMBERSHIP_POLICY_STUDENT_ROUTE = {
  key: 'MEMBERSHIP_POLICY_STUDENT',
  path: 'estudiantil/',
};

export const MEMBERSHIP_POLICY_ROUTES = [
  MEMBERSHIP_POLICY_PREMIUM_ROUTE,
  MEMBERSHIP_POLICY_DUO_ROUTE,
  MEMBERSHIP_POLICY_FAMILY_ROUTE,
  MEMBERSHIP_POLICY_STUDENT_ROUTE,
];
